<template>
    <div style="height: 100%;display: flex;flex-direction: column;background: #F9F9F9;">
        <div style="height: 96px;padding:38px 16px 0">
            <div @click="goBack" style="line-height: 48px;display: inline-block;">
                <a-icon style="color:rgba(4, 4, 4, 1);font-size: 16px;margin-right: 11px;" type="left" />
                <span style="color:rgba(44, 54, 74, 1);font-size:15px;">导出记录</span>
            </div>
        </div>
        <div ref="scrollWrap" @scroll.passive="handleScroll" style="flex: 1;overflow-y: auto;position: relative;padding-bottom: 24px;">
            <div style="padding:0 16px">
                <div v-for="(item,index) in outputData" :key="index" style="height: 116px;border-radius: 8px;background: #fff;padding: 12px 16px;margin-top:16px;">
                    <div style="color:rgba(44, 54, 74, 1);font-size: 15px;font-weight: bold;">描述</div>
                    <div style="margin-top:12px;display: flex;">
                        <div style="flex: 1;">
                            <div style="color:rgba(103, 110, 125, 1);font-size: 12px;">导出数据量：{{item.exportCount}}</div>
                            <div style="color:rgba(179, 184, 193, 1);font-size: 12px;margin-top:4px;">{{item.beginTime}}</div>
                            <div style="color:rgba(179, 184, 193, 1);font-size: 12px;">{{item.endTime}}</div>
                        </div>
                        <div style="display: inline-block;">
                            <div v-if="item.downloadUrl==''" style="color:rgba(255, 195, 0, 1);font-size: 13px;">
                                <a-icon type="clock-circle" />
                                <span style="margin-left:2px;">下载中...</span>
                            </div>
                            <span @click="copyUrl(item.downloadUrl)" v-if="item.downloadUrl!=''" style="display: inline-block;width: 88px;height: 32px;text-align: center;line-height: 32px;background: rgba(66, 223, 228, 1);border-radius: 16px;color:#fff;font-size: 14px;">复制链接</span>
                        </div>
                    </div>
                   
                </div>
                <div style="text-align:center;padding:16px;color:#999">
                    <!-- <span v-if="loading">加载中...</span> -->
                    <span v-if="total2==outputData.length&&total2!=0">没有更多了</span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'MobileDownload',
        props: {
            msg: String
        },
        data() {
            return {
                outputData: [],
                total2: 0,
                currentPage2: 1,
                pageSize2: 10,
                loading: false,
                finished: false
            } 
        },

        methods: {
            goBack() {
                this.$router.push("/MobileRecord")
            },
            queryOutputData(num) {
                if(num == 1){
                    this.currentPage2 = 1
                }
                this.axios(
                    {
                    method:'get',
                    url:'/api/smsRecord/export/list', 
                    params: {
                        minCreateTime: '',
                        maxCreateTime: '',
                        current: this.currentPage2,
                        size: 10,
                        desc: '',
                    }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.total2 = response.data.data.total
                        if(num == 1){
                            this.outputData = response.data.data.records
                        }else{
                            this.outputData = this.outputData.concat(response.data.data.records)
                        }
                        if (this.outputData.length == this.total2) {
                            this.finished = true
                        }else{
                            this.finished = false
                        }
                        this.loading = false
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            loadData(){
                if (this.loading || this.finished) return
                this.loading = true
                this.currentPage2 = this.currentPage2 + 1
                this.queryOutputData(2)
            },
            copyUrl(url) {
                const text = url

                const textarea = document.createElement('textarea')
                textarea.value = text

                // ✅ H5 关键设置
                textarea.setAttribute('readonly', '')
                textarea.style.position = 'fixed'
                textarea.style.top = '0'
                textarea.style.left = '0'
                // textarea.style.opacity = '0'
                textarea.style.fontSize = '12px'

                document.body.appendChild(textarea)

                // ✅ iOS 必须这样选中
                textarea.focus()
                textarea.setSelectionRange(0, textarea.value.length)

                let success = false
                try {
                    success = document.execCommand('copy')
                } catch (e) {
                    console.error(e)
                }

                document.body.removeChild(textarea)

                success
                    ? this.$message.success('复制成功')
                    : this.$message.error('复制失败') 
            },
            handleScroll () {
                console.log("执行滚动")
                console.log(this.loading)
                console.log(this.finished)
                if (this.loading || this.finished) return

                const el = this.$refs.scrollWrap
                if (!el) return

                const scrollBottom = el.scrollHeight - el.scrollTop - el.clientHeight
                console.log('距离底部距离为'+scrollBottom)
                // ✅ 距离底部 50px 触发
                if (scrollBottom < 50) {
                    this.loadData()
                }
            },
        },
        mounted: function() {
            this.queryOutputData(1)
        }
    }
</script>

<style scoped lang="less">

</style>
  